import React from 'react';
import {
  Form,
  Field,
  Formik,
} from 'formik';
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import {
  ButtonAprobar,
  ButtonCancel,
  TextAreaBase,
} from 'components/Controls';
import PropTypes from 'prop-types';
import { Check } from '@material-ui/icons';
import { green } from '@material-ui/core/colors';

class FormComentario extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      comentario: '',
    };
  }

  render() {
    const {
      open,
      close,
      estado,
      onSubmit,
      isWaiting,
    } = this.props;

    const { comentario } = this.state;

    const messageEstado = `¿Desea cambiar el estado a ${estado}?`;

    return (
      <Dialog
        open={open}
        onClose={close}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {messageEstado}
        </DialogTitle>
        <DialogContent>
          <Formik
            initialValues={{ comentario }}
            onSubmit={onSubmit}
          >
            {() => (
              <Form>
                <Grid container direction="row" justify="center">
                  <Field
                    name="comentario"
                    label="Comentario"
                    component={TextAreaBase}
                  />
                </Grid>
                <DialogActions>
                  <ButtonCancel onClick={close} />
                  <ButtonAprobar
                    label="Aceptar"
                    color={green[500]}
                    icon={<Check style={{ marginRight: 12, fontSize: 20 }} />}
                    type="submit"
                    disabled={isWaiting}
                  />
                </DialogActions>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    );
  }
}

FormComentario.propTypes = {
  open: PropTypes.bool,
  close: PropTypes.func,
  onSubmit: PropTypes.func,
  estado: PropTypes.string,
  isWaiting: PropTypes.bool,
};

export default FormComentario;
